import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as formActions from '../../Redux/Actions/form';
import * as userAuthActions from '../../Redux/Actions/user';
import {toastMessage} from '../utils/toast';
import CreateForm from '../CreateForm';
import {LoaderContainer} from '../CreateForm/styles';
import Warning from '../Ui/400';
import AamerLoader from '../Ui/Loader';

class EditForm extends Component{

    state = {
        loading: false,
        data: {},
        fieldsData: [],
        errStatus: 200
    };

    async componentDidMount(){
        const {formID} = this.props.match.params;
        await this.getIndividualForm(formID);
    }

    getIndividualForm = (formID) => {
        this.setState({loading: true});
        const { history, userAuthLogout } = this.props;
        const {formMetaData, reArrangeFieldData, createWorkflowAction, serviceCardData} = this.props;
        formActions.getIndividualForm(formID).then(res => {
            if(res && res.data){
                let response = res.data[0];
                let form = JSON.parse(response.json);
                formMetaData({title: response.name, description: response.description, arabictitle: form.arabictitle, arabicdescription: form.arabicdescription});
                reArrangeFieldData(form.formFields);
                createWorkflowAction(...form.actions);
                serviceCardData(form.serviceCards);
                this.setState({
                    loading: false,
                    data: response
                });
            }else{
                toastMessage('error', 'Unable to load the form');
            }
        }).catch(err => {
            this.setState({errStatus: err.response.status});
            if(err.response.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    componentWillUnmount = () => {
        const {formMetaData, reArrangeFieldData, createWorkflowAction, serviceCardData} = this.props;
        formMetaData({});
        reArrangeFieldData([]);
        createWorkflowAction({});
        serviceCardData([]);
    } 

    render(){
        const { errStatus, loading, data } = this.state;
        const { history } = this.props;

        if(errStatus === 400){
            return <Warning history={history} />;
        }

        return(
            <> 
                {loading ? <LoaderContainer><AamerLoader /></LoaderContainer> :
                 <CreateForm formID={data.id} history={history} />}
            </>
        );
    };
};


const mapDispatchToProps = dispatch => ({
    formMetaData: data => dispatch(formActions.formMetaData(data)),
    reArrangeFieldData: data => dispatch(formActions.reArrangeFieldData(data)),
    createWorkflowAction: data => dispatch(formActions.createWorkflowAction(data)),
    serviceCardData: data => dispatch(formActions.serviceCardData(data)),
    userAuthLogout: () => dispatch(userAuthActions.userAuthLogout())
});

export default connect(null, mapDispatchToProps)(EditForm);